import { Meter } from '../types'

export const getMeters = (): Meter[] => {
    return [
        {
            meterId: 1,
            meterNumber: '1',
            meterName: '11001',
            facilityName: '433 Hamptons',
            facilityAddress: {
                address1: 'New York, NY, 10014, USA',
            },
        },
        {
            meterId: 2,
            meterNumber: '2',
            meterName: '11002',
            facilityName: '304 Cooper Street',
            facilityAddress: {
                address1: 'New York, NY, 10014, USA',
            },
        },
        {
            meterId: 3,
            meterNumber: '3',
            meterName: '11003',
            facilityName: '101 Independence Street',
            facilityAddress: {
                address1: 'New York, NY, 10014, USA',
            },
        },
        {
            meterId: 4,
            meterNumber: '4',
            meterName: '11004',
            facilityName: '103 Independence Street',
            facilityAddress: {
                address1: 'New York, NY, 10014, USA',
            },
        },
        {
            meterId: 5,
            meterNumber: '5',
            meterName: '11005',
            facilityName: '105 Independence Street',
            facilityAddress: {
                address1: 'New York, NY, 10014, USA',
            },
        },
        {
            meterId: 6,
            meterNumber: '6',
            meterName: '11006',
            facilityName: '107 Independence Street',
            facilityAddress: {
                address1: 'New York, NY, 10014, USA',
            },
        },
    ]
}
